import { client } from '@/common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationRemoveContract = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, contractId }) => {
            return client.delete(
                replaceParameters(CONTRACTS.UPDATE_CONTRACT.url, { contractAccessId, contractId })
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationRemoveContract;